// Static station metadata (names, regions). Used for the landing page and demo mode;
// the live dashboard loads stations from GET /api/stations.
export const STATIONS = [
  {
    id: "davis",
    name: "Davis",
    cimisId: "6",
    region: "Sacramento Valley",
    county: "Yolo County",
    lat: 38.53569,
    lng: -121.77636,
    climate: { chillHours: 1050, chillPortions: 68, meanTemp: 60.6, amplitude: 14.8, diurnal: 24 },
  },
  {
    id: "manteca",
    name: "Manteca",
    cimisId: "70",
    region: "Northern San Joaquin Valley",
    county: "San Joaquin County",
    lat: 37.83482,
    lng: -121.22319,
    climate: { chillHours: 985, chillPortions: 64, meanTemp: 61.4, amplitude: 15.2, diurnal: 24 },
  },
  {
    id: "modesto",
    name: "Modesto",
    cimisId: "71",
    region: "Central San Joaquin Valley",
    county: "Stanislaus County",
    lat: 37.64522,
    lng: -121.18776,
    climate: { chillHours: 940, chillPortions: 62, meanTemp: 62.0, amplitude: 15.6, diurnal: 25 },
  },
  {
    id: "parlier",
    name: "Parlier",
    cimisId: "39",
    region: "Fresno District",
    county: "Fresno County",
    lat: 36.59744,
    lng: -119.50404,
    climate: { chillHours: 820, chillPortions: 57, meanTemp: 63.2, amplitude: 16.4, diurnal: 26 },
  },
  {
    id: "shafter",
    name: "Shafter",
    cimisId: "5",
    region: "Southern San Joaquin Valley",
    county: "Kern County",
    lat: 35.53256,
    lng: -119.28179,
    climate: { chillHours: 690, chillPortions: 51, meanTemp: 64.6, amplitude: 16.8, diurnal: 26 },
  },
];

export const getStationById = (id) => STATIONS.find((s) => s.id === id);

// Station view models keyed by numeric CIMIS station number (same shape as the API's stations).
export const STATIC_STATION_VMS = STATIONS.map((s) => ({
  id: Number(s.cimisId),
  slug: s.id,
  name: s.name,
  lat: s.lat,
  lng: s.lng,
  elevationFt: null,
}));

export const regionFor = (stationNo) => STATIONS.find((s) => Number(s.cimisId) === stationNo)?.region;

export const CENTRAL_VALLEY_VIEW = { center: [37.15, -120.45], zoom: 7 };
export const WORLD_VIEW = { center: [28, -55], zoom: 2 };
